import useAppSelector from '@sportson/core-web/hooks/useAppSelector';
import useBreakpoint from '@sportson/core-web/hooks/useBreakpoint';
import { shallowEqual } from 'react-redux';
import { transformBackgroundImageGroup } from 'libs/wordpress/utils/transformBackground';

import CmsModules from '@sportson/core-web/libs/wordpress/content/CmsModules';
import ArticleStructuredData from '@sportson/core-web/components/metadata/structuredData/ArticleStructuredData';
import Breadcrumbs from 'components/Breadcrumbs';

import { ArticlePageHero } from 'components/Article/ArticlePageHero';

const Article = () => {
    const isMobile = useBreakpoint({ to: 'tablet.sm' });
    const device = isMobile ? 'mobile' : 'desktop';
    const heroContent = useAppSelector(({ page }) => page.data?.heroContent, shallowEqual);
    const pageContent = useAppSelector(({ page }) => page.data?.pageContent, shallowEqual);
    const articleTitle = useAppSelector(({ page }) => page.data?.title, shallowEqual);
    const image = useAppSelector(({ page }) => page.data?.articleImage, shallowEqual);
    const summary = useAppSelector(({ page }) => page.data?.articleSummary?.summary, shallowEqual ?? []);
    const altTitle = useAppSelector(({ page }) => page.data?.articleSummary?.alternativeTitle, shallowEqual ?? []);
    const tag = useAppSelector(({ page }) => page.data?.categories[0], shallowEqual) ?? [];
    const breadcrumbs = useAppSelector(({ page }) => page.data?.breadcrumbs, shallowEqual) ?? [];
    const category = useAppSelector(({ page }) => page?.data.categories[0], shallowEqual) ?? '';

    const articleData = {
        image: transformBackgroundImageGroup(image.backgroundImage, device),
        tag,
        title: altTitle || articleTitle,
        summary,
    };

    const breadcrumbData = [
        ...breadcrumbs.map((b) => ({ permalink: b.permalink, title: b.title })),
        ...(category
            ? [{ permalink: `${breadcrumbs[breadcrumbs.length - 1]?.permalink}?category=${category}`, title: category }]
            : []),
        { permalink: null, title: articleData.title },
    ];

    return (
        <>
            {/* TODO: NOTE: comment back Structured Data!!! */}
            {/* <ArticleStructuredData /> */}
            <Breadcrumbs
                gridColumn="standard"
                p={['16px 24px 16px 12px', null, null, null, null, '16px 40px']}
                breadcrumbs={breadcrumbData}
            />

            <ArticlePageHero {...articleData} />

            {heroContent && <CmsModules isHero data={heroContent} />}
            {pageContent && <CmsModules data={pageContent} />}
        </>
    );
};

export default Article;
